import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByReferUserId } from '../../service/UserReferService';

export default function MyRefer() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode, appUser
  } = useGlobalContext();

  const id = appUser.id;
  const [userRefers, setUserRefers] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUserReferList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, '', currentPage, limit, keyword);
      console.log("users", response);
      setUserRefers(response.userRefers || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserReferList(page);
  }, [page]);



  return (
    <>
      <Helmet>
        <title>My Refers | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>My Refers</h1>
            <span><Link to="/"> Dashboard </Link> / My Refer List</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='table-content'>
                  <div className="mobile-scroll">
                    <table className='table table-bordered table-condensed'>
                      <thead>
                        <tr>
                          <th>Sl.no</th>
                          <th>Image</th>
                          <th>Member name</th>
                          <th>Mobile</th>
                          <th>Whatsapp</th>
                          <th>Email</th>
                          <th>Gender</th>
                          <th>City</th>
                          <th>Address</th>
                          <th>Pincode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userRefers && userRefers.length > 0 ? (
                          userRefers.map((userRefer, index) => (
                            <tr key={userRefer.id}>
                              <td>{(page - 1) * limit + index + 1}</td>
                              <td>
                                {userRefer.user.image ? (
                                  <img
                                    src={`${config.imageBasePath}/user/${userRefer.user.id}.${userRefer.user.image}`}
                                    alt={userRefer.user.name}
                                    className='img-fluid image-xs'
                                  />
                                ) : (
                                  <span className="text-muted" style={{ fontSize: '12px' }}>No Profile Picture</span>
                                )}
                              </td>
                              <td>{userRefer.user.name}</td>
                              <td>{userRefer.user.mobile}</td>
                              <td>{userRefer.user.whatsapp}</td>
                              <td>{userRefer.user.email} </td>
                              <td>{userRefer.user.gender.name}</td>
                              <td>{userRefer.user.city.name}</td>
                              <td>{userRefer.user.address}</td>
                              <td>{userRefer.user.pincode}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="9" className="text-center">No members found</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
